export const RESET = 'EXCMDEVICEMODEL_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICEMODEL_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICEMODEL_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICEMODEL_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICEMODEL_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICEMODEL_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICEMODEL_UPDATE_UPDATE_RETRIEVED'
